import React from 'react';
import Header from './components/Header';
import Body from './components/Body';


function App() {
  return (
    <>
      <Header />
      <Body />

    </>
  );
}

export default App;
